// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1327":"0ccad94c","6050":"0ccad94c","6426":"0ccad94c","8636":"0ccad94c","8946":"0ccad94c"}[chunkId] + ".chunk.css";
};